<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Editar contacto</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true"><img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20"></span>
        </button>
    </div>

    <div class="modal-body">
        <app-user-data-form [listener]="this"
            [model]="userData"
            [showTitleAndCard]="false"
            [showBankingData]="false">
        </app-user-data-form>
    </div>
</ng-template>

<div class="form-row">
    <div class="col-lg-7 mb-0">
        <h6 class="subtitulo-pack-form">Titular en operador donante</h6>
        <div class="jumbotron-form2">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <span class="label-ad-text2">Titular en operador donante</span>
                    <br>
                    <!-- Nombre titular operador -->
                    <span class="label-ad-text">
                        {{ userData.firstName + ' ' + userData.surname1 + ' ' + userData.surname2 }}
                    </span>
                </div>
                <small class="text-muted btn-muted">
                    <button class="btn btn-green btn-sm" (click)="open(content)">Añadir</button>
                </small>
            </div>
        </div>
    </div>
</div>
